import { months } from '../../../utilities/calendar-utilities';
import { ChangeCalendarView } from './Calendar';
import { Trans } from 'react-i18next';
import CoreComponent from 'utilities/component-utilities/CoreComponent';

// #region model definition
interface CalendarMonthProps {
    onChange: (month: ChangeCalendarView, e: React.MouseEvent) => void,
    value: number,
    viewYear: number,
    isDisabled: (month: number, year: number) => boolean,
    highlightDates?: Date[] | null,
    name: string
}
interface CalendarMonthState { }
// #endregion model definition
class CalendarMonth extends CoreComponent<CalendarMonthProps, CalendarMonthState> {
    constructor(props: CalendarMonthProps) {
        super(props);
        this.state = {

        };
    }

    private onChange = (month: number, disabled: boolean, e: React.MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
        if (disabled) return;
        this.props.onChange({ month, view: 'date' }, e);
    }

    // #region render

    private renderMonths = () => {
        const monthView: React.ReactNode[] = [];
        let rowView: React.ReactNode[] = [];

        for (let index = 0, row = 0; index < months.length; index++, row++) {
            const month = months[index];
            const disabled = this.props.isDisabled(index, this.props.viewYear);
            rowView.push(
                <td key={`month-${month}`}>
                    <button
                        type="button"
                        onClick={e => this.onChange(index, disabled, e)}
                        className={`month-cell w-full h-full
                            ${this.props.value === index ? 'selected' : ''}
                            ${disabled ? 'disabled' : ''}
                            ${this.props.highlightDates?.some(d => d.getMonth() === index) ? 'highlight' : ''}
                        `}
                        name={`${this.props.name}-calendar-month-${months[index]}`}
                    >
                        <span><Trans i18nKey={`calendar.months.${months[index]}.name`} /></span>
                    </button>
                </td>
            );

            if (row === 2) {
                row = -1;
                monthView.push(<tr key={`month-row-${monthView.length}`}>{[...rowView]}</tr>);
                rowView = [];
            }
        }

        return monthView;
    }

    render() {
        return (
            <>
                <header className="calendar-header">
                    <div className='pt-2 pb-2'>
                        <button type='button' onClick={e => this.props.onChange('year', e)} >{this.props.viewYear}</button>

                        <button type='button' className='ml-6' onClick={e => this.props.onChange('date', e)} >
                            {this.t('button.back')}
                        </button>
                    </div>
                </header>
                <div className="calendar-content">
                    <table className="month-view">
                        <tbody>
                            {this.renderMonths()}
                        </tbody>
                    </table>
                </div>
            </>
        );
    }
    // #endregion render
}
export default CalendarMonth;
